import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'

import { HttpInterceptorService } from 'api/module'
import { NotifyService, UtilCommonModule } from 'common/util/module'
import { UtilPickersModule } from 'common/util.pickers/module'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale/module'
import { MediaCustomFieldsModule } from 'media.customFields'
import { TasksModule } from 'tasks/module'
import { MediaTagsModule } from 'media.tags'

import { NotificationSettingsComponent } from './components/notificationSettings.component'
import { NotificationSettingModalComponent } from './components/notificationSettingModal.component'
import { OneTimeAccessTokenModalComponent } from './components/oneTimeAccessTokenModal.component'
import { AppNavbarComponent } from './components/appNavbar.component'
import { AppSidebarComponent } from './components/appSidebar.component'
import { UploaderPanelComponent } from './components/uploaderPanel.component'
import { RsyncTaskParamsComponent } from './components/rsyncTaskParams.component'

import { UITestView } from './views/uiTestView.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([]),
    LocaleModule.forChild(),
    UtilCommonModule,
    UtilPickersModule,
    EntityListModule,
    TasksModule,
    MediaCustomFieldsModule,
    NgbNavModule,
    NgbTooltipModule,
    MediaTagsModule,
  ],
  declarations: [
    OneTimeAccessTokenModalComponent,
    NotificationSettingsComponent,
    NotificationSettingModalComponent,
    UITestView,
    AppNavbarComponent,
    AppSidebarComponent,
    UploaderPanelComponent,
    RsyncTaskParamsComponent,
  ],
  exports: [
    OneTimeAccessTokenModalComponent,
    NotificationSettingsComponent,
    NotificationSettingModalComponent,
    UITestView,
    AppNavbarComponent,
    AppSidebarComponent,
    UploaderPanelComponent,
  ],
})
export class MainModule {
  constructor (
    notify: NotifyService,
    interceptor: HttpInterceptorService,
    translate: TranslateService,
  ) {
    interceptor.sessionExpired$.subscribe(() => {
      notify.error(translate.instant('Your session has expired'))
    })
  }
}

export default MainModule

export { BeforeUnloadService } from './services/beforeUnload.service'
export { IdentityService } from './services/identity.service'
export { ModernizrService } from './services/modernizr.service'
export { ParametersService } from './services/parameters.service'
